/** The composer's file copy, as the chat-files prototype words it. */
export const COMPOSER_FILE_TEXTS = {
  send: 'Send — Enter',
  writeToSend: 'Write something to send',
  attach: 'Attach files',
  remove: 'Remove',
  retry: 'Retry',
  cancelUpload: 'Cancel the upload',
  waitForUpload: 'Wait for the upload to finish',
  waitForUploads: 'Wait for the uploads to finish',
  removeFailed: 'Remove the file that failed',
  uploadFailed: 'Upload failed',
  unreadable: 'Can’t read this file',
  showLess: 'Show less',
  foldTitle: 'Fold the list',
  dismiss: 'Dismiss',
  show: 'Show',
  showTitle: 'Show where it is',
  unsupported: 'this type isn’t supported',
  empty: 'the file is empty',
  alreadyAttached: 'already attached to this message',
  alreadyInConversation: 'already in this conversation',
} as const
